import { spUsersApi } from './spusers';

export const sendOtpApi = spUsersApi.injectEndpoints({
  endpoints: (builder) => ({

    sendOtp: builder.mutation({
      query: ({ payload }) => ({
        url:    '/phone/send-otp',
        method: 'POST',
        body:   payload,
      }),
    }),

  }),
  overrideExisting: false,
});

export const { useSendOtpMutation } = sendOtpApi;